import { UploadOutlined } from "@ant-design/icons";
import { Space, message, Upload } from "antd";
import React, { useState } from "react";
import { errorMessage } from "../../helpers/errorMessageFunc";
import { Button, Typography, Stack, Box } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';

function csvToArray(str, delimiter = ",") {
  const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
  const rows = str.slice(str.indexOf("\n") + 1).split("\n");

  let arr = rows.filter(function (row) { return row && row.length > 0 });

  arr = arr.map(function (row) {
    let values = [];
    let value = '';
    let isQuoted = false;

    // we check for each char if it's part of quotes
    // if yes, we treat entire quoted as single value (eg: value = $10,000)
    // if no, then we apply delimiter and break it
    for (let char of row) {
      if (char === delimiter && !isQuoted) {
        values.push(value);
        value = '';
      } else if (char === '"') {
        isQuoted = !isQuoted;
      } else {
        value += char;
      }
    }
    values.push(value);

    const el = headers.reduce(function (object, header, index) {
      object[header.trim()] = values[index];
      return object;
    }, {});
    return el;
  });
  return arr;
}


const CsvUpload = (props) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = () => {

    setUploading(true); // You can use any AJAX library you like

    const csvFile = fileList[0];

    const reader = new FileReader();

    reader.onload = function (e) {
      const text = e.target.result;
      let data = csvToArray(text);
      //   data = data.map((ele) => {
      //     return {
      //       ...ele,
      //       amount: parseFloat(ele.amount)
      //     }
      //   })

      props.setCsvData(data);

    };

    reader.readAsText(csvFile);

    setUploading(false)
    message.success(`${csvFile.name} file uploaded successfully`);
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      props.setCsvData([]);
    },
    beforeUpload: (file) => {
      const isCsv = file.type === "text/csv";

      if (!isCsv) {
        errorMessage(`${file.name} is not a csv file`);
      }
      setFileList([file]);
      // if True is returned Upload attempts to POST directly to the current app url
      // from docs:
      //    When returned value is Upload.LIST_IGNORE, the list of files that have been uploaded will ignore it.
      // returning just Upload.LIST_IGNORE prevents the component from firing off a doomed-to-fail POST
      return Upload.LIST_IGNORE;
    },
    fileList,
  };
  return (
    <Stack direction="row" spacing={2} alignItems="flex-start">
      <Box display="flex" flexDirection="column" alignItems="center">
        <Upload
          {...uploadProps}
          maxCount={1}
          accept=".csv"
          fileList={fileList}
          showUploadList={{
            showRemoveIcon: true, // show delete
            showPreviewIcon: false,
            showDownloadIcon: false,
          }}
          itemRender={(originNode, file, fileList, actions) => (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                width: 140,
                mt: 0.5,
                borderRadius: 1,
              }}
            >
              <Typography
                variant="caption"
                noWrap
                sx={{ maxWidth: 120 }}
                title={file.name}
              >
                {file.name}
              </Typography>
              <DeleteIcon
                fontSize="medium"
                onClick={actions.remove}
                sx={{ cursor: 'pointer', color: 'gray', ml: 1 }}
              />
            </Box>
          )}
        >
          <Button
            startIcon={<CloudUploadIcon />}
            disableElevation
            size="small"
            variant="outlined"
            color="secondary"
            sx={{ fontSize: 14, textTransform: 'none', minWidth: 140 }}
          >
            Select File
          </Button>
        </Upload>
      </Box>

      <LoadingButton
        onClick={handleUpload}
        disabled={fileList.length === 0}
        loading={uploading}
        disableElevation
        size="small"
        variant="contained"
        color="primary"
        sx={{ fontSize: 14, minWidth: 140, textTransform: 'none' }}
      >
        {uploading ? "Uploading" : "Start Upload"}
      </LoadingButton>
    </Stack>

  );
};

export default CsvUpload;
